<template>
  <div :id="id"></div>
</template>
<script>
export default {
  name: 'DfpSlot',
  props: {
    size: {
      type: Array,
      default: null
    },
    path: {
      type: String,
      default: ''
    },
    mappingRequired: {
      type: Boolean,
      default: false
    },
    mappingJobSearch: {
      type: Boolean,
      default: false
    },
    mappingTraining: {
      type: Boolean,
      default: false
    },
    mappingHomepagePopup: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  mounted() {
    const {
      path,
      size,
      id,
      mappingRequired,
      mappingJobSearch,
      mappingTraining,
      mappingHomepagePopup
    } = this

    window.googletag = window.googletag || {}
    window.googletag.cmd = window.googletag.cmd || []
    window.googletag.cmd.push(() => {
      window.googletag.pubads().refresh()
      const mapping = window.googletag
        .sizeMapping()
        .addSize([320, 400], [320, 100]) // Accepts both common mobile banner formats
        .addSize([360, 640], [336, 280]) // Same width as mapping above, more available height
        .addSize([750, 200], [336, 280]) // Landscape tablet
        .addSize([1050, 200], [1100, 100])
        .addSize([1200, 200], [1100, 100])
        .build() // Desktop
      const mapping2 = window.googletag
        .sizeMapping()
        .addSize([320, 400], [320, 100])
        .addSize([320, 200], [250, 150])
        .addSize([360, 640], [320, 100])
        .addSize([750, 200], [728, 90])
        .addSize([1050, 200], [728, 90])
        .build()
      const mapping3 = window.googletag
        .sizeMapping()
        .addSize([320, 400], [320, 100])
        .addSize([360, 640], [320, 100])
        .addSize([750, 200], [720, 300])
        .addSize([1050, 200], [720, 300])
        .addSize([1200, 200], [720, 300])
        .build()
      const mapping4 = window.googletag
        .sizeMapping()
        .addSize([320, 400], [320, 100])
        .addSize([360, 640], [336, 280])
        .addSize([750, 200], [720, 300])
        .addSize([1050, 200], [720, 300])
        .addSize([1200, 200], [720, 300])
        .build()
      if (mappingRequired && window.googletag.pubads()) {
        window.googletag
          .defineSlot(path, size, id)
          .addService(window.googletag.pubads())
          .defineSizeMapping(mapping)
      } else if (mappingJobSearch && window.googletag.pubads()) {
        window.googletag
          .defineSlot(path, size, id)
          .addService(window.googletag.pubads())
          .defineSizeMapping(mapping2)
      } else if (mappingTraining && window.googletag.pubads()) {
        window.googletag
          .defineSlot(path, size, id)
          .addService(window.googletag.pubads())
          .defineSizeMapping(mapping3)
      } else if (mappingHomepagePopup && window.googletag.pubads()) {
        window.googletag
          .defineSlot(path, size, id)
          .addService(window.googletag.pubads())
          .defineSizeMapping(mapping4)
      } else {
        window.googletag
          .defineSlot(path, size, id)
          .addService(window.googletag.pubads())
      }
      window.googletag.pubads().enableSingleRequest()
      window.googletag.pubads().collapseEmptyDivs()
      window.googletag.enableServices()
      window.googletag.display(id)
    })
  }
}
</script>
